import AboutSection from "../components/AboutSection";
import WhyChoose from "../components/WhyChoose";

export default function About() {
  return (
    <>
      <AboutSection />
      <WhyChoose />
    </>
  );
}
